import { useApi } from './useApi';
import { apiService } from '../services/api';

interface ApproachStep {
  id?: number;
  number: number;
  title: string;
  description: string;
}

interface BehandelingenApproachData {
  id?: number;
  documentId?: string;
  title: string;
  subtitle?: string;
  description?: string;
  steps: ApproachStep[];
  image?: {
    id?: number;
    url?: string;
    alternativeText?: string;
    formats?: {
      large?: { url: string; width: number; height: number; };
      medium?: { url: string; width: number; height: number; };
      small?: { url: string; width: number; height: number; };
      thumbnail?: { url: string; width: number; height: number; };
    };
    width?: number;
    height?: number;
  };
  createdAt?: string;
  updatedAt?: string;
  publishedAt?: string;
}

export function useBehandelingenApproach() {
  return useApi<BehandelingenApproachData | null>(apiService.getBehandelingenApproach);
}